import styled from "styled-components";

// Image
import grain from "./../../assets/images/grainBackground.svg";

// Lottie
import Lottie from "lottie-react";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background-color: #f8c933; */
  /* background-image: url(${grain}); */
  /* background-blend-mode: multiply; */
  /* width: 100%; */
  width: 380px;
  position: absolute;
  height: 760px;
  margin-bottom: 60px;
`;

export const PlayGround = styled.div`
  height: 50%;
  aspect-ratio: (1 / 2);
  margin: 50px;
  flex-direction: column;
  max-width: 380px;
  display: flex;
  flex: 1;
`;

export const MatchBoxStrip = styled.img`
  height: 40px;
  width: 100%;
`;

export const CenterAbout = styled.div`
  background-color: #463048;
  width: 550px;
  height: 600px;
  display: flex;
  color: #171312;
  background-image: url(${grain});
  background-blend-mode: multiply;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* overflow-y: scroll;
  &&::-webkit-scrollbar {
    display: none;
  } */
`;

export const CenterAboutArea = styled.div`
  width: 550px;
  height: 700px;
  margin-top: 10px;
  /* margin: 20px 0; */
  background-color: #463048;
  color: #171312;
  display: flex;
  background-image: url(${grain});
  background-blend-mode: multiply;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  &&::-webkit-scrollbar {
  }
`;

export const CenterArea = styled.div`
  background-color: #463048;
  width: 380px;
  height: 630px;
  display: flex;
  color: #171312;
  background-image: url(${grain});
  background-blend-mode: multiply;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const CenterAreaOne = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 30px;
  padding-right: 30px;
  overflow-y: scroll;
  &&::-webkit-scrollbar {
  }
  margin-bottom: 20px;
  padding-bottom: 20px;
  margin-top: 20px;
`;

export const CenterAreaTwo = styled.div`
  flex: 0.5;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  padding-bottom: 20px;
  align-items: center;
`;

export const CenterAboutOne = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 30px;
  padding-right: 30px;
  color: white;
  margin-bottom: 20px;
  margin-top: 360px;
`;

export const Label = styled.img`
  height: 50px;
  width: 94%;
`;

export const LabelContent = styled.p`
  margin-top: -35px;
  font-weight: 900;
  color: #ec613e;
`;

export const Header = styled.span`
  text-align: center;
  color: #f8c933;
  font-size: 16px;
  margin-top: 20px;
  letter-spacing: 1px;
`;

export const HeaderAbout = styled.div`
  display: flex;
  text-align: center;
  padding-left: 30px;
  padding-right: 30px;
  color: #f8c933;
  font-size: 24px;
  letter-spacing: 1px;
  margin-top: 30px;
  font-weight: 700;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  margin: 10px;
  color: #f8c933;
  letter-spacing: 1px;
  align-items: center;
  font-size: 12px;
`;

export const MatchBoxStripArea = styled.span`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
`;

export const MatchBoxStripButton = styled.button`
  position: absolute;
  right: 0;
  height: 100%;
  background-color: transparent;
  background: none;
  border: none;
  top: 1.75px;
  cursor: pointer;
  width: 30px;
  height: 38px;
`;

export const AboutHeader = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: white;
  /* margin-top: 15px; */
`;

export const AboutText = styled.div`
  font-size: 15px;
  font-weight: 300;
  color: white;
`;

export const Logo = styled.img`
  height: 40px;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const Animation = styled.div`
  position: absolute;
  background-color: "red";
  right: -70px;
  bottom: 140px;
`;

export const LottieAnimation = styled(Lottie)`
  height: 100px;
  width: 100px;
  display: ${(props) => (props.info ? "none" : "")};
`;

export const HeaderTwo = styled.span`
  color: #f8c933;
  margin-top: 10px;
  font-size: 15px;
  padding-left: 30px;
  padding-right: 30px;
`;

export const Anchor = styled.span`
  color: #f8c933;
  text-decoration: underline;
  font-weight: 400px;
  cursor: pointer;
`;
export const ButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 550px;
`;
export const DivButton = styled.button`
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`;
export const ButtonImg = styled.img`
  width: 30px;
  height: 30px;
`;
export const OuterDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 380px;
  /* margin-top: 10px; */
  margin-bottom: 10px;
`;
export const BeginTitle = styled.img`
  width: ${(props) => (props.isEnglish === true ? "300px" : "220px")};
  height: ${(props) => (props.isEnglish === false ? "40px" : "auto")};
  margin-top: 20px;
`;
